import { useMediaQuery } from '@mui/material'
import { InfoIcon } from '@phosphor-icons/react'

import { Button } from '@components/shared/Button'
import { emotionTheme } from '@styles/theme'
import { BaseModal2 } from '../BaseModal2'

import {
  BUDGET_VALIDATION_POPUP_BODY,
  BUDGET_VALIDATION_POPUP_CONFIRM_BUTTON_TEXT,
  BUDGET_VALIDATION_POPUP_INTRO,
  BUDGET_VALIDATION_POPUP_TITLE
} from './constants'

import type { BudgetValidationModalProps } from './types'

import * as S from './styles'

// RC05: bloqueio de interação até confirmação — sem X, sem fechar por backdrop/Esc, botão único "Ciente".
export const BudgetValidationModal = ({ open, onConfirm }: BudgetValidationModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <BaseModal2
      open={open}
      title={BUDGET_VALIDATION_POPUP_TITLE}
      headerIcon={<InfoIcon size={20} weight="fill" color={emotionTheme.colors.primary} />}
      onClose={() => {}}
      disableClose
      width={isMobile ? 'calc(100% - 20px)' : 520}
    >
      <S.Content>
        <S.IntroMessage>{BUDGET_VALIDATION_POPUP_INTRO}</S.IntroMessage>
        <S.BodyMessage>{BUDGET_VALIDATION_POPUP_BODY}</S.BodyMessage>

        <S.ButtonWrapper>
          <Button width={160} colorType="solidBlue" onClick={onConfirm}>
            {BUDGET_VALIDATION_POPUP_CONFIRM_BUTTON_TEXT}
          </Button>
        </S.ButtonWrapper>
      </S.Content>
    </BaseModal2>
  )
}
